export const FETCH_USERS_SEARCH_PENDING = 'FETCH_USERS_SEARCH_PENDING';
export const FETCH_USERS_SEARCH_SUCCESS = 'FETCH_USERS_SEARCH_SUCCESS';
export const FETCH_USERS_SEARCH_ERROR = 'FETCH_USERS_SEARCH_ERROR';

export const RESET_USERS_SEARCH = 'RESET_USERS_SEARCH';
